module.exports = __webpack_public_path__ + "static/media/Test47.7cda0522.bmp";